import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../button/Button';
import dispatchEvent from '../../../fns/common/dispatchEvent';

import gen from '../../../assets/images/gen-banner.gif';
import owners from '../../../assets/images/owners-banner.gif';
import epack from '../../../assets/images/epack-banner.gif';
import metapack from '../../../assets/images/metapack-banner.gif';

const Collections = () => {
  return (
    <section className="the-collections">
      <div className="px-5 md:px-10">
        <h1 className="lt-white font-bold text-center mb-5 mt-5 text-3xl md:text-4xl">
          The Collections
        </h1>
        <div className="collections-list">
          <div className="single-collection" id="genesis">
            <div>
              <img
                className="w-full h-[380px] object-cover rounded-lg"
                src={gen}
                alt="genesis metafan"
              />
            </div>
            <div className="mt-5 mb-5">
              <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                Genesis Metafans Collection
              </h2>
              <p className="text-grey text-base md:text-lg">
                Each NFT is unique. Own a complete set, The Jock, The
                Cheerleader, The Die Hard, and the Average Joe, and get enhanced
                member benefits!
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Collection
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    10k
                  </h2>
                </div>
              </div>
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Traits
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    700+ hand-drawn
                  </h2>
                </div>
              </div>
              <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Avatars
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    4
                  </h2>
                </div>
              </div>
            </div>
            <div className="mint">
              <Button
                variant="Primary"
                className=""
                onClick={() => dispatchEvent('opensaleModalRequested')}
              >
                Mint a MetaFan NFT
              </Button>
            </div>
          </div>
          <div className="single-collection" id="obg">
            <img
              src={owners}
              className="w-full h-[380px] object-cover rounded-lg"
              alt="Owners’ Box Guest"
            />
            <div className="mt-5 mb-5">
              <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                Owners’ Box Guest
              </h2>
              <p className="text-grey text-base md:text-lg">
                Included in the Genesis collection, these are the rarest and
                most valuable. If minted, the lucky holder gets exponentially
                greater prizes if they win our community contests, and greater
                chances of winning our IRL ticket giveaways!
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Collection
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    18 in 10k
                  </h2>
                </div>
              </div>
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Traits
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    unique one-of-one
                  </h2>
                </div>
              </div>
              <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item"></div>
            </div>
            <div className="mint">
              <Button
                variant="Primary"
                className=""
                onClick={() => dispatchEvent('opensaleModalRequested')}
              >
                Mint a MetaFan NFT
              </Button>
            </div>
          </div>
          <div className="single-collection" id="fanepack">
            <img
              src={epack}
              className="w-full h-[380px] object-cover rounded-lg"
              alt="FanEpacks"
            />
            <div className="mt-5 mb-5">
              <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                FanEpacks
              </h2>
              <p className="text-grey text-base md:text-lg">
                Free with each MetaFans NFT mint (*minus gas fees).
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Collection
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    10k
                  </h2>
                </div>
              </div>
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Traits
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    400+ hand-drawn
                  </h2>
                </div>
              </div>
              <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item"></div>
            </div>
            <div className="mint">
              <Button
                variant="Primary"
                className=""
                onClick={() => dispatchEvent('fanEpackModalRequested')}
              >
                Claim Your FanEpack
              </Button>
            </div>
          </div>
          <div className="single-collection" id="metapacks">
            <img
              src={metapack}
              className="w-full h-[380px] object-cover rounded-lg"
              alt="MetaPacks"
            />
            <div className="mt-5 mb-5">
              <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                MetaPacks
              </h2>
              <p className="text-grey text-base md:text-lg">
                One-of-One FanEpack NFTs. Keep your fingers crossed when you
                mint your FanEpack, as you might acquire one of these!
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Collection
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    22
                  </h2>
                </div>
              </div>
              <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                <div>
                  <p className="text-grey font-medium text-sm md:text-base tracking-tight mb-0">
                    Traits
                  </p>
                  <h2 className="lt-white font-bold text-3xl md:text-4xl tracking-tight mb-3">
                    unique one-of-one
                  </h2>
                </div>
              </div>
              <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item"></div>
            </div>
            <div className="mint">
              <Button
                variant="Primary"
                className=""
                onClick={() => dispatchEvent('opensaleModalRequested')}
              >
                Mint a MetaFan NFT
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Collections;
